import { TimeMeasure } from "../../../../../../base/utilities";

export class SourceProcessorBase<TSource> {
  constructor(private createSource: () => TSource) {}

  protected doAsync<T>(process: (s: TSource) => Promise<T>, name?: string, description?: string): Promise<T> {
    return TimeMeasure.logAsync(
      name ? name : "",
      async () => process(this.createSource()),
      description ? description : "",
      TimeMeasure.debug
    );
  }
}
